import Swiper from 'swiper'
import { Pagination, Autoplay, EffectFade } from 'swiper/modules'

// SwiperのCSS
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/autoplay'

window.addEventListener('load', function () {
  const mainElement = document.querySelector('body')
  if (mainElement && mainElement.classList.contains('lp_region')) {
    const seminarList = document.querySelector('.seminar_list_wrapper')
    const btnMore = document.querySelector('.btn_more')
    btnMore.addEventListener('click', function () {
      seminarList.classList.add('is-current')
    })
  }
})
